<template>
  <div id="sessions">
    <div class="container">

      <div class="header-block">
        <InfoBlock
            :title="$getModuleTitle(currentEvent.modules, 'livestreams')"
            :desc="$t('sessions.info_description')"
            :button="null"
            :url="null"
          />
      </div>

      <Nodata
        :title="$getModuleTitle(currentEvent.modules, 'livestreams')"
        :description="(saloonId == null && searchTerm == null && searchTerm != '') ? $t('contentNotFound') : $t('contentFilterNotFound')"
        anim="holacon-sessions-lottie"
        :loading="$store.state.eventLoading == 'sessions'"
        v-if="currentSessions.length == 0"
        :button="$t('refresh')"
        @btnClick="$store.dispatch('getSessions', { id: currentEvent.id, searchTerm: null, route: false })" />

      <div class="sessions">
         <SessionBlock
            v-if="currentSessions.filter(k => k.type == 2 && k.isActive).length"
            :data="currentSessions.filter(k => k.type == 2 && k.isActive)"
            :type="'Speaker'"
          />

          <SessionBlock
            v-if="currentSessions.filter(k => k.type == null && k.isActive).length"
            :data="currentSessions.filter(k => k.type == null && k.isActive)"
            :type="'Attendee'"
          />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import SessionBlock from "../../modules/SessionBlock";
import InfoBlock from "../../modules/InfoBlock";
export default {
  name: "LiveStreams",
  components: { SessionBlock, InfoBlock },
  data() {
    return {
      moment,
      searchTerm: null,
      saloonId: null,
      timeout: null
    };
  },
  methods: {
    searchFilter() {
      if (this.searchTerm != null && this.timeout == null) {
        this.timeout = setTimeout(() => {
          this.$store.dispatch("getSessions", { searchTerm: this.searchTerm, id: this.currentEvent.id, route: false });
          this.timeout = null;
        }, 1000);
      }
    },
  },
  mounted() {
    this.$nextTick(() => { 
      this.$store.dispatch("getSessions", { id: this.currentEvent.id, route: false });
    });
  },
  computed: {
    currentEvent() {
      return this.$store.getters.getEvent;
    },
    currentSessions() {
      return this.$store.getters.getSessions;
    },
  },
};
</script>

<style lang="less">
#sessions {
  background-color: #F1F3F6;
  min-height: calc(~"100vh");
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0px 20px;

  .container {
    display: block;
    max-width: 1120px;
    width: inherit;
    margin: 0 auto;
    margin-bottom: 40px;

    .sessions {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-gap: 16px;
      margin: 0px;
    }
  }

}

@media (max-width: 768px) {
#sessions {
  padding: 0px;
  padding-bottom:60px;
  .container {
    padding: 0px 12px;
    .sessions {
      grid-template-columns: 1fr !important;
    }
  }
}
}

</style>



// WEBPACK FOOTER //
// src/components/event/Sessions.vue